module.exports = __webpack_public_path__ + "static/01-46139737f146a674894c40071dfc4a5a.jpg";